import React, { useState } from "react";
import Comment from "_c/Comment";
import s from "styled-components";
import { Button } from "_c/button";
import ResponseForm from "_c/response-form/index";
import PT from "prop-types";

const Wrap = s.div`
  margin-top: 25px;
  @media(max-width: 991px) {
    margin-bottom: 25px;
  }
`;

const ButtonsWrap = s.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`;
export const LoadMoreWrap = s.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const Comments = ({ comments, id, user, ...props }) => {
  const [showForm, setShowForm] = useState(false);
  const [respondTo, setRespondTo] = useState(null);
  const onCreateComment = async payload => {
    await props.addComment(payload);
    setShowForm(false);
  };
  return (
    <Wrap>
      <ul>
        {comments.map(comment => (
          <Comment
            onRemove={props.removeComment}
            allowPhoto
            key={comment._id}
            comment={comment}
            t={props.t}
            onComment={onCreateComment}
            isOwner={props.authUserId === comment.author._id}
          />
        ))}
      </ul>
      <ButtonsWrap>
        {!showForm && props.isAuth && (
          <Button
            medium
            onClick={() => {
              setShowForm(true);
              setRespondTo(null);
            }}
          >
            {props.t("common:comment")}
          </Button>
        )}
      </ButtonsWrap>
      <ResponseForm
        onClose={() => setShowForm(false)}
        allowPhoto
        t={props.t}
        isOpen={showForm}
        onSubmit={onCreateComment}
      />
    </Wrap>
  );
};
Comments.propTypes = {
  authUserId: PT.string,
  isAuth: PT.bool,
  comments: PT.array,

  addComment: PT.func.isRequired,
  removeComment: PT.func.isRequired
};

export default Comments;
